<template>
  <div class="solidity-contract-detail">
    <common-bg-plate>
      <detail-table :title="title" :table-col="tableCol" :list="list"></detail-table>
      <detail-section title="合约关联任务">
        <template #actions>
          <btn-style :btn-list="btnList"></btn-style>
        </template>
        <solidity-task-list
          ref="taskList"
          :contract-id="this.$route.query.contractId"
          @goDetail="onGoTaskDetail"
          @popConfirmRestart="onPopConfirmRestart"
        ></solidity-task-list>
      </detail-section>
    </common-bg-plate>
    <restart-solidity-detector-task
      :task-info="taskInfo"
      :dialog-visible.sync="showRestartSolidityDetectorTask"
      @restartSuccess="onRestartTaskSuccess"
    ></restart-solidity-detector-task>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import solidityTaskList from './components/solidityTaskList'
import restartSolidityDetectorTask from './restartSolidityDetectorTask'
import idIconImg from '@/assets/images/tableIcon/id-icon.png'
import nameImg from '@/assets/images/tableIcon/contract-name.png'
import timeImg from '@/assets/images/tableIcon/time.png'
import versionImg from '@/assets/images/tableIcon/n-version.png'
import typeImg from '@/assets/images/tableIcon/n-type.png'
import addTimeImg from '@/assets/images/tableIcon/n-clock-add.png'
import checkTimeImg from '@/assets/images/tableIcon/n-clock-check.png'
import taskImg from '@/assets/images/tableIcon/n-task.png'

export default {
  name: 'SolidityContractDetail',
  components: {
    solidityTaskList,
    restartSolidityDetectorTask
  },
  data() {
    return {
      title: '合约基本信息',
      tableCol: [
        { label: '合约ID', icon: idIconImg, value: 'ID' },
        { label: '合约名', icon: nameImg, value: 'Filename' },
        { label: '文件类型', icon: typeImg, value: 'Type', formatter: this.transType },
        { label: 'Solidity版本', icon: versionImg, value: 'SolcVersion' },
        { label: '关联任务数', icon: taskImg, value: 'TaskCount' },
        { label: '创建时间', icon: addTimeImg, value: 'CreatedAt', formatter: this.formatTime },
        { label: '更新时间', icon: checkTimeImg, value: 'UpdatedAt', formatter: this.formatTime }
      ],
      list: {
        ID: '',
        Filename: '',
        TaskCount: 0,
        Type: '',
        SolcVersion: '',
        CreatedAt: 0,
        UpdatedAt: 0
      },
      showRestartSolidityDetectorTask: false,
      taskInfo: {
        ID: '',
        ContractID: '',
        ContractFilename: '',
        Status: 0,
        CreatedAt: 0,
        StartedAt: 0,
        FinishedAt: 0
      },
      btnList: [
        {
          btnContent: '刷新',
          click: () => {
            return this.getTaskList()
          },
          icon: 'icon-refresh',
          type: 'default'
        }
      ]
    }
  },
  mounted() {
    this.getContractInfo()
    this.getTaskList()
  },
  methods: {
    ...mapActions([]),
    getContractInfo() {
      let self = this
      this.$apis.contractdetector
        .getSolidityContractInfo({
          contract_id: self.$route.query.contractId
        })
        .then(res => {
          if (res && res.data && res.code === 1) {
            self.list = res.data
          }
          // console.log(res)
        })
    },
    getTaskList() {
      this.$refs.taskList.refresh(this.$route.query.contractId)
    },
    transType(data, value) {
      let type = data[value]
      if (type == 'solidity') {
        return '源码文件'
      } else if (type == 'bytecode') {
        return '字节码文件'
      }
    },
    formatTime(data, value) {
      let time = data[value]
      if (time) {
        return this.$utils.dateFormat('YYYY-mm-dd HH:MM', new Date(time))
      } else {
        return this.$constants.EMPTY
      }
    },
    onGoTaskDetail(row) {
      this.taskInfo = row
      this.$router.push({
        name: 'solidityTaskDetail',
        query: {
          taskId: this.taskInfo.ID
        }
      })
    },
    onPopConfirmRestart(row) {
      this.taskInfo = row
      this.showRestartSolidityDetectorTask = true
    },
    onRestartTaskSuccess() {
      this.getTaskList()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.solidity-contract-detail {
  @include adaptation(
    (
      --solidity-contract-detail-base-info-height: 382px,
      --solidity-contract-detail-task-section-unavailable-height: 88px
    )
  );
  --solidity-contract-detail-min-height: var(--base-main-router-body-avaliable-height);
  --solidity-contract-detail-task-list-min-height: calc(var(--solidity-contract-detail-min-height) - var(--solidity-contract-detail-base-info-height) - var(--solidity-contract-detail-task-section-unavailable-height));

  min-height: var(--solidity-contract-detail-min-height);

  .normal-table-wrap {
    height: 100%;
    min-height: var(--solidity-contract-detail-task-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--solidity-contract-detail-task-list-min-height);
      }


      .normal-table {
        height: 100%;
        min-height: var(--solidity-contract-detail-task-list-min-height);
      }
    }
  }
}
</style>
